import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, Cylinder, ObjectProps, useDragConstraint } from "../utils";
import MonitorA from "./MonitorA";
import MonitorB from "./MonitorB";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 300,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [2.5, 0.01, 4.8], mass: 30, position: [-4.65, -3.5, 0], type: 'Box' }, // memo:支えのため、見えない当たり判定を作成
      { args: [12, 0.5, 5], mass: 150, position: [0, 3.25, 0], type: 'Box' },

      { args: [0.2, 12, 0.2], mass: 10, position: [-5.9, 2.5, -2.4], type: 'Box' },
      { args: [0.2, 12, 0.2], mass: 10, position: [-5.9, 2.5, 2.4], type: 'Box' },
      { args: [0.2, 12, 0.2], mass: 10, position: [-3.4, 2.5, -2.4], type: 'Box' },
      { args: [0.2, 12, 0.2], mass: 10, position: [-3.4, 2.5, 2.4], type: 'Box' },
      { args: [0.2, 7, 0.2], mass: 10, position: [5.9, 0, -2.4], type: 'Box' },
      { args: [0.2, 7, 0.2], mass: 10, position: [5.9, 0, 2.4], type: 'Box' },

      { args: [2.5, 0.2, 0.2], mass: 5, position: [-4.65, 8.5, -2.4], type: 'Box' },
      { args: [2.5, 0.2, 0.2], mass: 5, position: [-4.65, 4, -2.4], type: 'Box' },
      { args: [2.5, 0.2, 0.2], mass: 5, position: [-4.65, 8.5, 2.4], type: 'Box' },
      { args: [2.5, 0.2, 0.2], mass: 5, position: [-4.65, 4, 2.4], type: 'Box' },
      { args: [0.2, 0.2, 4.8], mass: 5, position: [-5.9, 7.5, 0], type: 'Box' },
      { args: [0.2, 0.2, 4.8], mass: 5, position: [-5.9, 4.0, 0], type: 'Box' },
      { args: [0.2, 0.2, 4.8], mass: 5, position: [-5.9, 0, 0], type: 'Box' },
      { args: [0.2, 0.2, 4.8], mass: 30, position: [-5.9, -2.5, 0], type: 'Box' },
      { args: [0.2, 0.2, 4.8], mass: 30, position: [5.9, -2.5, 0], type: 'Box' },
      { args: [9.3, 0.2, 0.2], mass: 5, position: [1.25, 0, -2.4], type: 'Box' },

      { args: [2.5, 0.2, 4.8], mass: 30, position: [-4.65, 7.0, 0], type: 'Box' },
      { args: [2.5, 0.2, 4.8], mass: 30, position: [-4.65, -3.0, 0], type: 'Box' },


      { args: [1.5, 0.7, 1], mass: 30, position: [2, 3.25, -2.1], type: 'Box' },

      { args: [0.25, 0.25, 0.5], mass: 10, position: [1.7, 3.85, -2.1], type: 'Cylinder' },
      { args: [2.5, 0.5, 0.5], mass: 20, position: [2.3, 4.85, -2.7], rotation: [0, Math.PI / 4, Math.PI / 4], type: 'Box' },
      { args: [0.25, 0.25, 1.0], mass: 10, position: [2.9, 6, -3.3], type: 'Cylinder' },
      { args: [3.5, 0.5, 0.5], mass: 20, position: [1.25, 6.35, -3.1], rotation: [0, Math.PI / 24, -Math.PI / 24], type: 'Box' },

      { args: [0.25, 0.25, 0.5], mass: 10, position: [2.3, 3.85, -2.1], type: 'Cylinder' },
      { args: [2.5, 0.5, 0.5], mass: 20, position: [2.9, 4.85, -2.7], rotation: [0, Math.PI / 4, Math.PI / 4], type: 'Box' },
      { args: [0.25, 0.25, 1.0], mass: 10, position: [3.5, 6, -3.3], type: 'Cylinder' },
      { args: [2.5, 0.5, 0.5], mass: 20, position: [4.3, 7, -3.3], rotation: [0, 0, Math.PI / 4], type: 'Box' },
    ], 
    type: 'Kinematic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 3.25, 0]} args={[12, 0.5, 5]} />

      <Box position={[-5.9, 2.5, -2.4]} args={[0.2, 12, 0.2]} />
      <Box position={[5.9, 0, -2.4]} args={[0.2, 7, 0.2]} />
      <Box position={[-5.9, 2.5, 2.4]} args={[0.2, 12, 0.2]} />
      <Box position={[5.9, 0, 2.4]} args={[0.2, 7, 0.2]} />
      <Box position={[-3.4, 2.5, -2.4]} args={[0.2, 12, 0.2]} />
      <Box position={[-3.4, 2.5, 2.4]} args={[0.2, 12, 0.2]} />

      <Box position={[-4.65, 8.5, -2.4]} args={[2.7, 0.2, 0.2]} />
      <Box position={[-4.65, 4, -2.4]} args={[2.7, 0.2, 0.2]} />
      <Box position={[-4.65, 8.5, 2.4]} args={[2.7, 0.2, 0.2]} />
      <Box position={[-4.65, 4, 2.4]} args={[2.7, 0.2, 0.2]} />
      <Box position={[-5.9, 7.5, 0]} args={[0.2, 0.2, 4.8]} />
      <Box position={[-5.9, 4.0, 0]} args={[0.2, 0.2, 4.8]} />
      <Box position={[-5.9, 0, 0]} args={[0.2, 0.2, 4.8]} />
      <Box position={[-5.9, -2.5, 0]} args={[0.2, 0.2, 4.8]} />
      <Box position={[5.9, -2.5, 0]} args={[0.2, 0.2, 4.8]} />
      <Box position={[1.25, 0, -2.4]} args={[9.3, 0.2, 0.2]} />

      <Box position={[-4.65, 7.0, 0]} args={[2.5, 0.2, 4.8]} />
      <Box position={[-4.65, -3.0, 0]} args={[2.5, 0.2, 4.8]} />


      <Box position={[2, 3.25, -2.1]} args={[1.5, 0.7, 1]} color="#2a2a2a"/>

      <Cylinder position={[1.7, 3.85, -2.1]} args={[0.25, 0.25, 0.5, 12]} color="#2a2a2a" />
      <Box position={[2.3, 4.85, -2.7]} args={[2.5, 0.5, 0.5]} rotation={[0, Math.PI / 4, Math.PI / 4]} />
      <Cylinder position={[2.9, 6, -3.3]} args={[0.25, 0.25, 1.0, 12]} color="#2a2a2a" />
      <Box position={[1.25, 6.35, -3.1]} args={[3.5, 0.5, 0.5]} rotation={[0, Math.PI / 24, -Math.PI / 24]} />
      <Box position={[-0.5, 6.5, -2.75]} args={[1, 1, 0.5]} color="#2a2a2a" />

      <Cylinder position={[2.3, 3.85, -2.1]} args={[0.25, 0.25, 0.5, 12]} color="#2a2a2a" />
      <Box position={[2.9, 4.85, -2.7]} args={[2.5, 0.5, 0.5]} rotation={[0, Math.PI / 4, Math.PI / 4]} />
      <Cylinder position={[3.5, 6, -3.3]} args={[0.25, 0.25, 1.0, 12]} color="#2a2a2a" />
      <Box position={[4.3, 7, -3.3]} args={[2.5, 0.5, 0.5]} rotation={[0, 0, Math.PI / 4]} />
      <Box position={[5, 7.75, -3.1]} args={[1, 1, 0.5]} color="#2a2a2a" />

      <MonitorA position={[-0.5, 6.5, -2.5]} />
      <MonitorB position={[5, 7.75, -2.85]} />
    </group>
  );
};
